module.exports = __webpack_public_path__ + "static/img/four.43c23f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guoguoImg/four.png
// module id = 5rOL
// module chunks = 1